import { weekdayAndDate } from './fmt_utils'

function computePageTitle(title, match) {
    const day = weekdayAndDate(match.params.date)
    return title(day)
}

export function setPageTitle(title, match) {
    document.title = typeof title === 'function' ? computePageTitle(title, match) : title
}



// WEBPACK FOOTER //
// ./src/util/title_utils.js